import React from "react";

import Infinity from "../imgs/tandc/infinity.svg";
import Shake from "../imgs/tandc/shake.svg";
import Gift from "../imgs/tandc/gift.svg";
import Shares from "../imgs/tandc/shares.svg";
import Ads from "../imgs/tandc/ads.svg";

function TandC(props) {
  return (
    // <div className="bg-white py-8 px-2 lg:px-8 md:p-16 lg:p-24 rounded-xl md:mx-4 lg:mx-auto max-w-7xl">
    <div className="bg-white py-8 px-2 lg:px-8 md:px-10 lg:px-20 rounded-xl md:mx-4 lg:mx-auto max-w-7xl">
      <h1 className="font-black text-2xl lg:text-4xl mb-10 text-center">
        Terms and Conditions
      </h1>

      <div className="flex justify-center items-center">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-white">
          <div className="px-4 py-5">
            <div className="flex space-x-3 mb-4">
              <img src={Infinity} height={30} width={30} />
              <h1 className="text-[#052035] text-lg">
                Forever Premium Account
              </h1>
            </div>
            <p className="text-[#052035] text-sm lg:text-base">
              All patrons are entitled to a lifetime premium account starting
              from the date of their contribution, ensuring ongoing access to
              exclusive features and benefits.
            </p>
          </div>
          <div className="px-4 py-5">
            <div className="flex space-x-3 mb-4">
              <img src={Shake} height={30} width={30} />
              <h1 className="text-[#052035] text-lg">Recognition</h1>
            </div>
            <p className="text-[#052035] text-sm lg:text-base">
              Your name will be listed on our supporters page (or you can choose
              to stay anonymous).
            </p>
          </div>
          <div className="px-4 py-5">
            <div className="flex space-x-3 mb-4">
              <img src={Gift} height={30} width={30} />
              <h1 className="text-[#052035] text-lg">Gift Items</h1>
            </div>
            <p className="text-[#052035] text-sm lg:text-base">
              Patrons who donate ₦50k and above receive Hallimo-branded
              merchandise, including items like T-shirts, mugs, and more, based
              on the donation amount. These items are delivered to the patron's
              address after their contribution.
            </p>
          </div>
          <div className="px-4 py-5">
            <div className="flex space-x-3 mb-4">
              <img src={Shares} height={30} width={30} />
              <h1 className="text-[#052035] text-lg">Revenue Sharing</h1>
            </div>
            <p className="text-[#052035] text-sm lg:text-base">
              Patrons who donate between ₦1m and ₦5m will have a share in
              Hallimo's revenue, ranging from 0.5% to 2.5%, as a token of
              appreciation for their generous support. This comes with a formal
              agreement to acknowledge their contribution.
            </p>
          </div>
          <div className="px-4 py-5">
            <div className="flex space-x-3 mb-4">
              <img src={Ads} height={30} width={30} />
              <h1 className="text-[#052035] text-lg">Sponsored Ads</h1>
            </div>

            <p className="text-[#052035] text-sm lg:text-base">
              Patrons who donate ₦250k and above are entitled to have ads for
              their business or brand featured on the Hallimo platform and media
              channels. The duration of the ads will vary based on donation
              amount.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TandC;
